import React from "react";
import "../styles/Header.css";

const Header = () => {
  return <div className="header">Find Minimum number of Notes to Pay</div>;
};

export default Header;
